import React, { useState, useEffect } from "react";
import Charts from "./Charts";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { campaignDetailDate, convertToTitleCase } from "../../../services/Util";
import { getAxiosResponse } from "../../../services/authApiRoutes/APImethods";
import APIUrls from "../../../services/APIUrls";
import { compareDateWithCurrent, dateFormat } from "../../../services/Util";
import { RotatingLines } from "react-loader-spinner";
import Constants from "../../../Constants";
import { PieChart } from "react-minimal-pie-chart";
import $ from 'jquery'
import { useSelector} from "react-redux";
import CustomProgressBar from "../../global/CustomProgressBar";
import { useTranslation } from "react-i18next";
import DateFormat from "../../../pages/DateFormat";
import {DATE_FORMATS} from "../../../services/DateUtil";
import MemberRequestConfirmationPopup from "./MemberRequestConfirmationPopup";

export default function Overview(props) {
  const { t } = useTranslation();
  const translate = t;
  const workspaceId = props?.data?.id;
  const showModel = () => {
    document.body.classList.add("modal-open");
    setTimeout(()=>{
      $('#campaignDetailClose').trigger('focus');
    },500)
  };
  const [loader, setLoader] = useState(false);
  const [openReviews, setOpenReviews] = useState([]);
  const [campaignMemberRequest, setCampaignMemberRequest] = useState([]);
  const [campaignUsers, setCampaignUsers] = useState([])
  const [campaignActivityFeed, setActivityFeed] = useState([]);
  const [projectDeliveryStatus, setDeliveryStatus] = useState("");
  const [projectrefreshData, seprojectRefreshData] = useState("");
  const [projectStatusTotalCount,setTotalProjectCount] = useState(0)
  const [activityCount,setActivityCount] = useState(0)
  const [activityDataCheck,setActivityDataCheck] = useState([]);
  const [popupStatus, setPopupStatus] = useState("");
  const [requestId, setRequestId] = useState(-1);
  const [pageRefresh, setPageRefresh] = useState(true);

  const navigate=useNavigate()
  const param=useParams();
  const searchParams = new URLSearchParams(window.location.search);
  const query = searchParams.get('taskId');
   
  const {setProjectDileveryStatus,setRefreshProject,setReviewer ,setTab,projectStatus,setTaskId}=props;
  const bootstrapData = useSelector(
    (reduxStore) => reduxStore.customer_bootstrap_data
).value;

  useEffect(()=>{
    if(!projectrefreshData !==""){
      setRefreshProject(projectrefreshData)
    }
  },[projectrefreshData])

  useEffect(()=>{
   if(query && query !==undefined && query !==null){
    setTaskId(query)
   }
  },[])

  const addedMemberActivity=(customerUsers,contextId)=>{
     if(customerUsers && customerUsers?.length > 0 ){
      let data= customerUsers?.filter(data=>data?.userId===contextId)[0]
        return data?.firstName + " "+data?.lastName
     }
     return Constants.BLANK
  }

  const activityStringfyData = (activity, type, taskData,campaignActivityFeeds,activityData,customerUsers) => {
    switch (type) {
      case "workspace_project_added":
        return ` added project <a href=${"/project/" + activity?.contextId}>
                                      ${activity?.display}
                                    </a>to this campaign.`;
      case "workspace_created":
        return " created this campaign";

        case "topic_created":
          return `You started a new discussion <a href="#">contextDisplay</a>` ;
      case "workspace_updated":
        return `${campaignActivityFeeds?.length > 0 ? campaignActivityFeeds?.find(data => data?.userId === activity?.contextId)?.firstName + " " + campaignActivityFeeds?.find(data => data?.userId === activity?.contextId)?.firstName : Constants.BLANK} updated this campaign
        ${activityData?.entityAuditId && campaignActivityFeed?.entityAuditData && campaignActivityFeed?.entityAuditData?.length > 0
          ? campaignActivityFeeds?.entityAuditData[activityData?.entityAuditId]?.map(data => (
              "<div>" +
              "<span>" + data?.nameDisplay + ":" + (data?.after ? data?.after : "(none)") + " " + '--->' + "</span>" +
              "<span>" + data?.nameDisplay + ":" + (data?.before ? data?.before : "(none)") + "</span>" +
              "</div>"
            )).join('')
          : Constants.BLANK}`


        case "workspace_task_created":
          return (
              `created task
               <a href=${'/campaign/'}${param?.id}${'?taskId='}${activity?.contextId} >${taskData && Object.keys(taskData).length > 0 && taskData[activity?.contextId]?.name}</a>
               <a href=${'/campaign/'}${param?.id}${'?taskId='}${activity?.contextId} >${'View Task'}</a>`
               );
        
      case "workspace_project_removed":
        return ` removed project <a href=${"/project/" + activity?.contextId}>
        ${activity?.display}
      </a>from this campaign.`;

      case "workspace_member_removed":
    return ` You removed ${addedMemberActivity(campaignActivityFeed?.customerUsers,activity?.contextId)} from this campaign.`;

    case "workspace_member_added":
        return `added ${addedMemberActivity(customerUsers,activity?.contextId)} from this campaign.`;
      default:
        return "";
    }
  };
  const defaultLabelStyle = {
    fontSize: "4px",
    fontFamily: "sans-serif",
    fill: "#FFFFFF",
  };

  const colorCode = {
    UNKNOWN: "#D78281",
    AT_RISK: "#ff7253",
    ON_TRACK: "#0bc4d0",
    LATE: "#74bf48",
  };

  useEffect(() => {
    getAxiosResponse(APIUrls.CAMPAIGN_ACTIVITY_FEED(workspaceId))
      .then((res) => {
        if (res.data !== "") {
          setActivityFeed(res.data.data);
          setActivityDataCheck(res?.data?.data?.events)
        }
      }).catch(err=>{
        console.error(err)
      })
    getAxiosResponse(APIUrls.CAMPAIGN_PROJECT_DELIVERY_STATUS(workspaceId))
      .then((res) => {
        var pieData = [];var totalCount = 0
        if (res.data !== "") {
          Object.keys(res.data.data).map((item, i) => {
            if (res.data.data[item] > 0) {
              totalCount +=  res.data.data[item]
              pieData.push({
                title: res.data.data[item] +" "+item.replace(/_/g, ' '),
                value: res.data.data[item],
                color: colorCode[item],
                originalName:item
              });
            }
          })
          
          setDeliveryStatus(pieData);
        }
        setTotalProjectCount(totalCount)
      }).catch(err=>{
        console.error(err)
      })

    getAxiosResponse(
      APIUrls.CAMPAIGN_OPEN_REVIEWS +
        `?status=OPEN&type=APPROVE_LANGUAGE_OR_REQUEST_REVISION&type=REVIEW_PROJECT_ASSETS&onlyFollowed=false&page=-1&wId=${workspaceId}`
    )
      .then((res) => {
        if (res.data !== "") {
          setOpenReviews(res.data.data);
        }
      }).catch(err=>{
        console.error(err)
      })

  }, []);

  useEffect(() => {
    if(pageRefresh){
    getAxiosResponse(APIUrls.CAMPAIGN_MEMBER_REQUEST(param.id))
      .then((res) => {
        setCampaignMemberRequest(res?.data?.data?.result);
      }).catch(err => {
        console.error(err)
      });

    getAxiosResponse(APIUrls.WORKSPACE_BY_ID(param.id))
      .then((res) => {
        if (res.data.data !== "") {
          let members = res?.data?.data?.workspace.workspaceMembers.map(usr => {
            return usr.firstName + " " + usr.lastName + " (" + usr.roleSet.displayName + ")";
          })
          setCampaignUsers(members)
        }
      }).catch(err => {
        console.error(err)
      });

      setPageRefresh(false);
    }
  }, [pageRefresh]);


  $(document).ready(function(){
    $('#projectsTracking').next().find('svg').attr('aria-labelledby', 'projectsTracking');
  })
  const setReviewerFun=(userId)=>{
    setReviewer({status:"OPEN",type:"REVIEW",assigneeId:userId});
    setTab("tasks")
  }
  
  const editCampaign = () =>{
    navigate(`/campaign-edit/${param.id}`);
  }

  const handleClick = (event, segmentIndex) => {
    const clickedSegment = projectDeliveryStatus[segmentIndex];
    setProjectDileveryStatus(clickedSegment); // Retrieve the value of the clicked segment
  };

  const addActivity=()=>{
    let count= `?start=${activityCount + 15}`
    setActivityCount(activityCount + 15)
    getAxiosResponse(APIUrls.CAMPAIGN_ACTIVITY_FEED(workspaceId)+count)
    .then((res) => {
      if (res.data !== "") {
        setActivityFeed({...campaignActivityFeed,entityAuditData:{...campaignActivityFeed?.entityAuditData ,...res?.data?.data?.entityAuditData} ,taskData:{...campaignActivityFeed?.taskData,...res?.data?.data?.taskData},events:[...campaignActivityFeed?.events,...res?.data?.data?.events],customerUsers:[...campaignActivityFeed?.customerUsers,...res?.data?.data?.customerUsers]});
        setActivityDataCheck(res?.data?.data?.events)
      }
    }).catch(err=>{
      console.error(err)
    })
  }
  const handleKeydown = (event, segmentIndex) => {
    if(event.key===Constants.ENTER && !event.shiftKey){
      handleClick(event, segmentIndex);
    }
  };

  const showPopup = (status,event) => {
    setPopupStatus(status);
    document.body.classList.add("modal-open-7");
    setRequestId(parseInt(event.target.dataset.requestId));
  };

  return (
    <div className="listing-content mar-bot30">
      <div className="campaign_details-overview flex">
        <div className="left-content">
          <div className="campaign_details-left-up">
            <h5>{translate("campaign_page.campaign_details")}</h5>

            <table className="campaign_details-table">
              <tbody>
                <tr>
                  <th scope="row" className="head">{translate("campaign_page.campaign_owner")}</th>
                  <td className="text">
                    {props?.data?.owner?.firstName +
                      " " +
                      props?.data?.owner?.lastName}
                  </td>
                </tr>
                <tr>
                  <th scope="row" className="head">Campaign Id</th>
                  <td className="text">
                    {props?.data?.id} 
                  </td>
                </tr>
                <tr>
                  <th scope="row" className="head">{translate("campaign_page.campaign_created")}</th>
                  <td className="text">
                    <DateFormat date={props?.data?.createdDate} format={DATE_FORMATS.DATE_TIME} />
                  </td>
                </tr>
                <tr>
                  <th scope="row" className="head">{translate("campaign_page.campaign_due_date")}</th>
                  <td className="text">
                    <DateFormat date={props?.data?.dueDate} format={DATE_FORMATS.DATE_TIME} />
                  </td>
                </tr>
                <tr>
                  <th scope="row" className="head">{translate("campaign_page.tags")}</th>
                  <td className="text">
                    {props?.data?.tags?.length === 0 ? (
                      "No tags selected"
                    ) : (
                      <ul>
                        {props?.data?.tags && props?.data?.tags.length > 0 && props?.data?.tags?.map((tags, index) => {
                          return (
                            <li key={index}
                            >
                              {tags}
                            </li>
                          );
                        })}
                      </ul>
                    )}
                  </td>
                </tr>
                <tr>
                  <td className="head"></td>
                  <td className="text">
                    {" "}
                    <button onClick={showModel} aria-label="More details" id="showMoreCapaignDetail">
                     {translate("campaign_page.more_details")}
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
            <div className="members-camaign mar-top20">
               <h5 className="pb-15">Members</h5>
              {campaignUsers.map(usr =>
                <p>{usr}</p>)}
              {campaignMemberRequest.length > 0 ?
                <>
                  <p>The following users have requested access to this campaign. Click 'Accept' to add the user as a member to this campaign, or 'Reject' to dismiss the request.</p>

                  <div className="table-responsive global-table">
                    <table className="sortable" aria-label="Members">
                      <tr>
                        <th scope="col">User Name</th>
                        <th scope="col">Actions</th>
                      </tr>
                      <tbody>
                        {campaignMemberRequest.map((member, index) => {
                          return (
                            <tr key={index}>
                              <td>{`${member.user.firstName} ${member.user.lastName}`}</td>
                              <td>
                                <div className="flex-center btn-gap10 flex-align">
                                  <button className="font-weightnormal" data-request-id={`${member.id}`} onClick={(event) => showPopup("accept", event)}>Accept</button>
                                  <span aria-hidden="true">|</span>
                                  <button className="font-weightnormal" data-request-id={`${member.id}`} onClick={(event) => showPopup("reject", event)}>Reject</button>
                                </div>
                              </td>
                            </tr>
                          )
                        })}
                      </tbody>
                    </table>
                  </div></>
                : <></>
              }
            </div>
          </div>
          <div className="campaign_details-right-up">
            <h5 id="projectsStatus">{translate("campaign_page.projects_by_status")}</h5>
            {loader ? (
              <RotatingLines
                strokeColor="grey"
                strokeWidth="5"
                width="96"
                visible={loader}
              />
            ) : (
              <div className="pie-chart">
                <Charts
                  data={projectStatus}
                  projectCount={props?.totalProject}
                  refreshProject={seprojectRefreshData}
                />
              </div>
            )}
          </div>
          <div className="campaign_details-left-down">
            <h5 id="openReviews">{translate("campaign_page.open_reviews")}</h5>
            {openReviews.length !== 0 ? (
              <table className="open-review" aria-describedby="openReviews">
                <tbody>
                  {openReviews.map((reviews, index) => {
                    return (
                      <tr key={index}>
                        <td onClick={()=>setReviewerFun(reviews?.user?.userId)} className="head">
                          <Link  to="">
                            {reviews?.user?.firstName +
                              " " +
                              reviews?.user?.lastName}
                          </Link>
                        </td>
                        <td className="text">
                          {reviews?.count}{" "}
                          {reviews?.count > 1 ? "Open Reviews" : "Open Review"}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            ) : (
              <div className="no-data-display align-center">
                <i className="nodata-icon"></i>
                <p>{Constants.NO_DATA_FOUND}</p>
              </div>
            )}
          </div>
          <div className="campaign_details-right-down">
            <h5 id="projectsTracking">{translate("campaign_page.projects_tracking")}</h5>
            {Object.keys(projectDeliveryStatus).length !== 0 ? 
                  <div className="flex-center slide-bar-block" >
                   <div style={{ display: "flex", alignItems: "center" }}>
                   <div
                    className="chartBox"
                    style={{ maxWidth: "350px", display: "inline-flex" }}
                  >
                    
                    <PieChart
                      radius={35}
                      data={projectDeliveryStatus}
                      onClick={handleClick}
                      onKeyDown={(e, segmentIndex) => handleKeydown(e, segmentIndex)}
                      segmentsTabIndex={0}
                      style={{cursor:"pointer"}}
                      center={[40, 50]}
                      viewBoxSize={[100, 100]}
                      lineWidth={40}
                      totalValue={projectStatusTotalCount}
                      labelPosition={78}
                      label={({ dataEntry }) =>
                        `${Number.isInteger(dataEntry.percentage)?dataEntry.percentage: dataEntry.percentage?.toFixed(2)} %`
                      }
                      labelStyle={{
                        ...defaultLabelStyle,
                      }}
                    />
                    <strong></strong>
                    </div>
                    <div className="clorList">
                      <ul>
                        {projectDeliveryStatus.map((d) => {
                          return (
                            <li key={d.title}>
                              <span style={{ background: `${d.color}` }}> </span>
                              <small key={d.title}>{convertToTitleCase(d.title)}</small>
                            </li>
                          );
                        })}
                      </ul>
                    </div>
                    </div>
                  </div>
             : (
              <div className="no-data-display align-center">
                <i className="nodata-icon"></i>
                <p>{Constants.NO_DATA_FOUND}</p>
              </div>
            )}
          </div>
        </div>
        <div className="right-content activity-main">
          <h5>{translate("campaign_page.activity_feed")}</h5>
          <div className="activity-feed-outer">
            {campaignActivityFeed.length !== 0 ? (
              campaignActivityFeed.events.map((activity, index) => {
                return (
                  <div key={index}>
                    {compareDateWithCurrent(
                      activity.createdDate,
                      Constants.DATE_COMPARE_FORMAT
                    ) ? (
                      <div className="activity-feed-inner">
                        {index === 0 ? (
                          <span className="title"> Today</span>
                        ) : (
                          ""
                        )}
                        <ul className="activity-feed-table">
                          <li>
                            <span>
                              {dateFormat(
                                activity.createdDate,
                                Constants.HOUR_MIN_AM_PM
                              )}
                            </span>
                            {activity?.creatorDisplayName.substring(3)}
                            <p
                              dangerouslySetInnerHTML={{
                                __html: activityStringfyData(
                                  activity?.context,
                                  activity?.type,
                                  campaignActivityFeed?.taskData,
                                  campaignActivityFeed?.customerUsers.
                                  activity
                                ),
                              }}
                            ></p>
                          </li>
                        </ul>
                      </div>
                    ) : (
                      <div className="activity-feed-inner">
                        {index !== 0 ? (
                          dateFormat(campaignActivityFeed.events[index - 1]?.createdDate, Constants.DATE_COMPARE_FORMAT) !==
                          dateFormat(campaignActivityFeed.events[index]?.createdDate, Constants.DATE_COMPARE_FORMAT) ? (
                            <span className="title">
                              <DateFormat date={activity.createdDate} />
                            </span>
                          ) : ("")
                        ) : (
                          <span className="title">
                            <DateFormat date={activity.createdDate} />
                          </span>
                        )}
                        <ul className="activity-feed-table">
                          <li>
                            <span
                              className={
                                index !== 0
                                  ? dateFormat(campaignActivityFeed.events[index - 1]?.createdDate?.utcTimestamp, Constants.DATE_COMPARE_FORMAT) !==
                                    dateFormat(campaignActivityFeed.events[index].createdDate?.utcTimestamp, Constants.DATE_COMPARE_FORMAT) ? "hide" : ""
                                  : ""
                              }>
                              <DateFormat date={activity.createdDate} format={DATE_FORMATS.TIME_OF_DAY} />
                            </span>
                            {activity.creatorDisplayName.substring(3)}
                            <p
                              dangerouslySetInnerHTML={{
                                __html: activityStringfyData(
                                  activity.context,
                                  activity.type,
                                  campaignActivityFeed.taskData,
                                  campaignActivityFeed,
                                  activity,
                                  campaignActivityFeed?.customerUsers,
                                ),
                              }}
                            ></p>
                          </li>
                        </ul>
                      </div>
                    )}
                  </div>
                );
              })
            ) : (
              <div className="no-data-display align-center">
                <i className="nodata-icon"></i>
                <p>{Constants.NO_DATA_FOUND}</p>
              </div>
            )}
            {campaignActivityFeed.length !== 0 && activityDataCheck &&  activityDataCheck?.length > 0  ? <Link disabled={activityDataCheck && activityDataCheck?.length === 0}  onClick={addActivity}>View more Activity Feed</Link>:Constants.BLANK}
          </div>
        </div>
        {campaignMemberRequest.length > 0 &&
          <MemberRequestConfirmationPopup popupStatus={popupStatus} requestId={requestId} memberRequestData={campaignMemberRequest} setPageRefresh={setPageRefresh} />
        }
      </div>
    </div>
  );
}
